import { useHistory, useParams } from "react-router-dom";

import { UserReportPrint } from "@/components/reports/print";

import {
  CUSTOMER_USER_REPORT_PRINT_QUERY,
  CUSTOMER_USER_RESULT_PRINT_DETAILS_QUERY
} from "./graphql/printQueries";

export default function CustomerReportPrint() {
  const history = useHistory();
  const { reportSlug } = useParams();

  const handleClose = () => {
    history.push(`/reports/${reportSlug}/overview`);
  };

  return (
    <UserReportPrint
      reportSlug={reportSlug}
      reportPrintQuery={CUSTOMER_USER_REPORT_PRINT_QUERY}
      userResultPrintDetailsQuery={CUSTOMER_USER_RESULT_PRINT_DETAILS_QUERY}
      onClose={handleClose}
    />
  );
}
